// Chart colours in the Latlens brand: terracotta first, then its tints and
// neutral greys, so a chart reads as one system in light and dark.
export const CHART = {
  primary: '#F0642E',
  primarySoft: '#FF9A6E',
  neutral: '#8A9099',
  positive: '#1E9E5A',
};
/** Categorical series, in order of importance. */
export const SERIES = ['#F0642E', '#FFB08A', '#8A9099', '#C7CBD1', '#B23E12', '#5B6168'];
